import { 
    RELEASE_TENANT_REQUEST, 
    RELEASE_TENANT_SUCCESS, 
    RELEASE_TENANT_FAILURE,
    RESE_RELEASE_TENANT_SUCCESS
} from '../../../Constants/actionTypes';

import { API_RELEASE_TENENT } from '../../../Constants/apiUrls'


export const resetOnSuccessReleaseTenant = () => ({
    type: RESE_RELEASE_TENANT_SUCCESS
});

// Helper function to handle errors
const handleErrors = async (response) => {
    if (!response.ok) {
        const errorText = await response.text();
        try {
            const errorJson = JSON.parse(errorText);
            return errorJson.error || 'Unknown Error'; // Return the error message
        } catch (e) {
            return errorText || 'Unknown Error'; // Return the error text if JSON parsing fails
        }
    }
    return null; // No error
};

// Action creator for releasing a tenant
export const releaseTenant = (tenentNumber,tenentBookingEndTime,tenentBookingType) => async (dispatch, getState) => {
    dispatch({ type: RELEASE_TENANT_REQUEST });
    try {
        const state = getState();
        const accessToken = state.auth.accessToken; 
        const response = await fetch(API_RELEASE_TENENT, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${accessToken}`, 
            },
            body: JSON.stringify({
                bookingEndTime: tenentBookingEndTime,
                tenantNumber: tenentNumber,
                bookingTenantType: tenentBookingType,
            }),
        });
        const errorMessage = await handleErrors(response); // Check for errors
        if (errorMessage) {
            throw new Error(errorMessage); // Throw an error with the actual error message
        }
        const data = await response.json();
        dispatch({ type: RELEASE_TENANT_SUCCESS, payload: data });
    } catch (error) {
        let errorMessage;
        if (error.message === 'Failed to fetch'|| error.message.includes('NetworkError')) {
            errorMessage = 'Server is currently down. Please try again later.';
        } else {
            errorMessage = error.message;
        }
        dispatch({ type: RELEASE_TENANT_FAILURE, payload: errorMessage });
    }
};
